import React, { useEffect, useState } from 'react'
import axios from 'axios'
import PostReplyBox from './PostReplyBox'
import ActionButton from './ActionButton'
import Footer from './Footer'
import '../styles/global.css'
import btnStyles from '../styles/button.module.css'
import loaderStyles from '../styles/loader.module.css'
import errorStyles from '../styles/error.module.css'
import errorIcon from '../images/error.svg'

const pageStyles = {
	width: '85%',
	margin: '0 auto',
	maxWidth: '640px',
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center'
}

function WebMessagePage() {
	const [data, setData] = useState(null)
	const [loading, setLoading] = useState(false)
	const [postId, setPostId] = useState('')
	const [hasReply, setHasReply] = useState(false)

	useEffect(() => {
		const fetchPost = async () => {
			const queryParams = new URLSearchParams(window.location.search)
			const displayName = queryParams.get('d')
			const fetchPostId = queryParams.get('p')
			const apiBaseUrl = `${process.env.REACT_APP_API_BASE_URL}${process.env.REACT_APP_BASE_URL_PREFIX}`
			axios.defaults.baseURL = apiBaseUrl

			if (displayName && fetchPostId) {
				setLoading(true)

				try {
					const resp = await axios.get(`/post/${displayName}/${fetchPostId}`)
					setData(resp.data)
					setPostId(fetchPostId)
					// Set the document title using the displayName

					document.title = `@${displayName}`
				} catch (error) {
					console.error('Error fetching data:', error)
				}
				setLoading(false)
			}
		}
		fetchPost()
	}, [])

	const handleReply = (reply) => {
		setHasReply(reply)
	}

	return (
		<>
			<main style={pageStyles}>
				{loading ? (
					<p className={loaderStyles.loader}></p>
				) : data ? (
					<PostReplyBox
						profileImage={data && data.profileUrl}
						post={data && data.content}
						postId={postId}
						onReplying={handleReply}
					/>
				) : (
					<p className={errorStyles['error-big']}>
						<img src={errorIcon} alt='eror' />
						Opps! Something went wrong
					</p>
				)}
			</main>
			{!hasReply && (
				<>
					<div className={btnStyles['btn-container']}>
						<div className={btnStyles['btn-wrapper']}>
							<ActionButton />
						</div>
					</div>
					<Footer />
				</>
			)}
		</>
	)
}

export default WebMessagePage
